export default __webpack_public_path__ + "static/media/retake.0661ebac.png";